export const whatsappHandler = () => {
  const button = document.getElementById('whatsappButton'); // Replace with your button's ID
  // const buttonAlt = document.getElementById('whatsappButtonAlt'); // Replace with your button's ID
  const container = document.querySelector('.whatsapp-container');

  button.addEventListener('click', function () {
    if (container.classList.contains('show')) {
      container.classList.remove('show');
      container.classList.remove('showing');
      container.classList.add('hiding');
    } else {
      container.classList.remove('hiding');
      container.classList.add('show');
      container.classList.add('showing');
    }
    document.body.addEventListener('click', function (e) {
      if (!container.contains(e.target) && !button.contains(e.target) && e.target !== buttonAlt) {
        container.classList.remove('show');
        container.classList.remove('showing');
        container.classList.add('hiding');
      }
    });
  });
  // buttonAlt.addEventListener('click', function (e) {
  //   e.preventDefault();
  //   if (container.classList.contains('show')) {
  //     container.classList.remove('show');
  //     container.classList.remove('showing');
  //     container.classList.add('hiding');
  //   } else {
  //     container.classList.remove('hiding');
  //     container.classList.add('show');
  //     container.classList.add('showing');
  //   }
  //   document.body.addEventListener('click', function (e) {
  //     if (!container.contains(e.target) && !button.contains(e.target) && e.target !== buttonAlt) {
  //       container.classList.remove('show');
  //       container.classList.remove('showing');
  //       container.classList.add('hiding');
  //     }
  //   });
  // });
}